module.exports = __webpack_public_path__ + "assets/img/3.f07089d0.png";